module.exports = __webpack_public_path__ + "static/img/17.f950886.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/17.png
// module id = MIsa
// module chunks = 0